// export function getApplicablePrice({
//   priceList,
//   selectedUomId, // 🔑 required
//   sPriceListId,
//   businessDate = new Date(),
// }) {
//   if (!Array.isArray(priceList) || priceList.length === 0) return null;

//   const today = new Date(businessDate);
//   today.setHours(0, 0, 0, 0);

//   // 1️⃣ Filter by price list
//   let filtered = priceList.filter((p) => p.sPricelistId === sPriceListId);

//   if (filtered.length === 0) return null;

//   // 2️⃣ Apply UOM filtering
//   // 🔁 Backward compatibility
//   if (filtered.length === 1 && !filtered[0].uomId && !filtered[0].effectiveFrom) {
//     return filtered[0];
//   }

//   // 2️⃣ UOM matching (STRICT)
//   let uomFiltered = filtered.filter((p) => (p.uomId ? p.uomId === selectedUomId : true));

//   // 3️⃣ Date-based pricing
//   const dated = uomFiltered
//     .filter((p) => p.effectiveFrom)
//     .map((p) => ({
//       ...p,
//       effectiveDate: new Date(p.effectiveFrom),
//     }))
//     .filter((p) => p.effectiveDate <= today);

//   if (dated.length > 0) {
//     dated.sort((a, b) => b.effectiveDate - a.effectiveDate);
//     return dated[0];
//   }

//   // 5️⃣ Fallback → both effectiveFrom & uomId null
//   // 4️⃣ Fallback: UOM price without effective date
//   const uomNoDate = uomFiltered.find((p) => !p.effectiveFrom && p.uomId === selectedUomId);
//   if (uomNoDate) return uomNoDate;

//   // 5️⃣ Final fallback: legacy default price
//   return uomFiltered.find((p) => !p.effectiveFrom && !p.uomId) || null;
// }

export function getApplicablePrice({ priceList, selectedUomId, sPriceListId, businessDate = new Date() }) {
  if (!Array.isArray(priceList) || priceList.length === 0) return null;

  const today = new Date(businessDate);
  today.setHours(0, 0, 0, 0);

  // Helper: sort latest date first (future also allowed)
  const sortByLatestDate = (arr) =>
    arr
      .map((p) => ({
        ...p,
        effectiveDate: p.effectiveFrom ? new Date(p.effectiveFrom) : null,
      }))
      .sort((a, b) => {
        if (!a.effectiveDate && !b.effectiveDate) return 0;
        if (!a.effectiveDate) return 1;
        if (!b.effectiveDate) return -1;
        return b.effectiveDate - a.effectiveDate;
      });

  // 🔹 STEP 1: PriceList + UOM + Date
  let step1 = priceList.filter((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.uomId === selectedUomId && p.effectiveFrom);

  if (step1.length > 0) {
    return sortByLatestDate(step1)[0];
  }

  // 🔹 STEP 2: PriceList + UOM (no date)
  let step2 = priceList.find((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.uomId === selectedUomId && !p.effectiveFrom);

  if (step2) return step2;

  // 🔹 STEP 3: PriceList only (latest date)
  let step3 = priceList.filter((p) => (!sPriceListId || p.sPricelistId === sPriceListId) && p.effectiveFrom);

  if (step3.length > 0) {
    return sortByLatestDate(step3)[0];
  }

  // 🔹 STEP 4: Any UOM match (latest date)
  let step4 = priceList.filter((p) => p.uomId === selectedUomId && p.effectiveFrom);

  if (step4.length > 0) {
    return sortByLatestDate(step4)[0];
  }

  // 🔹 STEP 5: Default (no UOM, no date)
  return priceList.find((p) => !p.uomId && !p.effectiveFrom) || null;
}
